export default {
  drawer: null,
  color: "success",
  snack: {
    display: false,
    text: null,
    color: "#00ff00"
  },
  loading: false
};
